import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Text } from '../../../text/text';

export const OffBoardingStep5: React.FC = observer(() => {
    const { t } = useTranslation();

    return (
        <>
            <Text size="large" variant={'default'} bold>
                {t(`dialogs.offboarding.step5.text`)}
            </Text>
        </>
    );
});
